/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Allow_Original_Edit_LabelInputs */



/**
* | output |
* | --- |
* | "Allow Original Text Editing" |
*
* @param {Edit_Event_Group_Allow_Original_Edit_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_allow_original_edit_label = /** @type {((inputs?: Edit_Event_Group_Allow_Original_Edit_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Allow_Original_Edit_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Allow Original Text Editing")
	if (locale === "de") return /** @type {LocalizedString} */ ("Allow Original Text Editing")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allow Original Text Editing")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Allow Original Text Editing")
	if (locale === "es") return /** @type {LocalizedString} */ ("Allow Original Text Editing")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Allow Original Text Editing")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Allow Original Text Editing")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Allow Original Text Editing")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Allow Original Text Editing")
	return /** @type {LocalizedString} */ ("Allow Original Text Editing")
});